import React from 'react';
import './Plasticsprayer.css';
import img1 from '../../../imgs/Plasticspra2.webp';
import img2 from '../../../imgs/Plasticspra1.webp';  

const Plasticsprayer = () => {
  return (
    <div className="Plasticsp-card-container">
      <div className="Plasticsp-card card-with-text">
        <div className="card-text"> 
          <h2>Plastic Backpack Sprayer Making Solution</h2>
          <p>Extrusion Blow Molding Machine EB250P85PS1</p>
        </div>
        <img src={img1} alt="Sprayer Machine" />
      </div>

      <div className="Plastics-card card-only-image">
        <img src={img2} alt="Sprayer Product" />
      </div>
    </div>
  );
};

export default Plasticsprayer;
